import VoicePolicyTextField from './VoicePolicyTextField';
import { walkthroughIds } from '../constants';

const PatternField = (props) => (
    <VoicePolicyTextField
        {...props}
        name="pattern"
        label="Pattern"
        placeholder="Enter pattern"
        walkthroughid={walkthroughIds.ufPattern}
    />
);

export default PatternField;
